module.exports = __webpack_public_path__ + "static/media/01.3c846896.png";